const En = {
  "dashboard_contact-inappr-equip":
    "COVID-19 Contact with Inappropriate Equipment",
  "dashboard_multi-symptoms": "COVID-19 Multiple Symptoms",
  "dashboard_symptom-employee-health":
    "Symptoms since Contact with Employee Health",
  "dashboard_travel-outside": "Travel Outside NB",
  account_emailAddress: "Email Address",
  account_english: "English",
  account_firstName: "First Name",
  account_french: "French",
  account_interfaceLanguage: "Interface Language",
  account_lastName: "Last Name",
  account_minLength: "Minimum 6 characters",
  account_oneDigit: "At least 1 digit",
  account_oneLowercaseLetter: "At least 1 lowercase letter",
  account_oneSpecialChar: "At least 1 special character",
  account_oneUppercaseLetter: "At least 1 uppercase letter",
  account_personalInfo: "Personal Info",
  newpass: "Type new password",
  req_date: "Requested Date",
  confpass: "Retype new password",
  card_Num: "Access Card Number",
  signUpMsg: "SIGN UP",
  import_date: "Import Date",
  business_type: "Business Type",
  keywords: "Keywords",
  importer: "Importer",
  refine: "Refine",
  preview: "Preview",
  checkbox: "[ - ]",
  file_name: "File Name",
  file_date: "Date (UTC)",
  is_processed: "Processors",
  linked_to: "Links",
  preferredLang: "Preferred Language",
  account_settings: "Settings",
  account_update: "Update",
  account_updateFail: "Incorrect password.",
  account_updateSuccessful: "Update successful.",
  apply_changes: "Apply changes to :",
  this_occurrence_only: "This occurrence only",
  future_occurrences: "This occurrence and the future ones",
  auth_backToSignIn: "Back to Sign In",
  one: "One",
  multiple: "Multiple",
  signInBtn: "Log In",
  cardMsg: "(Will be used as your username)",
  successValid: "Your account has been successfully activated.",
  successValid2: "Your account has already been activated.",
  successValid3: "You may log in.",
  resent:
    "A validation link has been sent to your email address. Please click on the link to activate your account.",
  linkExpired1: "This activation link has expired.",
  linkExpired2: "To resend a new one, click on Resend.",
  resend: "RESEND",
  notyetActivated1: "This account is not yet activated.",
  notyetActivated2: "Please click on the activation link that was sent",
  notyetActivated3: "to you, or click on Resend to get a new one",
  arcturus_cloud: "Arcturus Cloud",
  arcturus_status: "Arcturus Cloud Service Status",
  auth_change: "Change",
  auth_emailAddress: "Username/Email Address",
  auth_iHaveAVerificationCode: "I have a verification code.",
  auth_incorrectEmailAddress: "Invalid username/email address",
  auth_invalidVerificationCode: "The verification code is invalid.",
  auth_keepMeLoggedIn: "Keep me logged in",
  auth_login: "Log In",
  auth_sendCode: "Send code",
  auth_emailOtpSignInHelp: "We will email you a one-time code to sign in.",
  auth_otpTitle: "Sign in",
  auth_otpDesc: "Enter the one-time code sent to your email.",
  auth_mfaTitle: "Multi-factor authentication",
  auth_mfaDesc: "Enter the verification code sent to your email.",
  auth_codeResent: "Code resent successfully",
  auth_resendCode: "Resend Code",
  role: "Filter",
  mdc_timeline: "Timeline",
  mdc_list: "List",
  ref: "Ref #",
  activity: "Activity",
  status: "Status",
  reqtime: "Requested Date/Time",
  PO: "PO",
  what_to: "What to ",
  loaded: "Loaded",
  empty: "Empty",
  create_another: "Create another",
  carrier: "Carrier",
  assigned_driver: "Assigned Driver",
  assigned_vehicle: "Assigned Vehicle",
  trailer: "Trailer/Container",
  zone_door: "Zone/Door",
  yard_visit: "Yard Visit",
  in_yard: "In Yard",
  person_visit: "Person Visit",
  auth_logout: "Log Out",
  vmi_requests: "Requests",
  vmi_orders: "Orders",
  drop: "Drop",
  pickup: "Pickup",
  switch: "Switch",
  liveload: "Live Load",
  liveunload: "Live Unload",
  miscellaneous: "Miscellaneous",
  reservation: "Reservation",
  newvisit: "YARD VISIT - NEW RESERVATION",
  activities: "Activities",
  summary: "Summary",
  move: "Move",
  load: "Load",
  unload: "Unload",
  createquestion: "CREATE QUESTIONNAIRE",
  auth_minLength: "Minimum 6 characters",
  auth_oneDigit: "At least 1 digit",
  auth_oneLowercaseLetter: "At least 1 lowercase letter",
  auth_oneSpecialChar: "At least 1 special character",
  auth_oneUppercaseLetter: "At least 1 uppercase letter",
  auth_pleaseEnterAnEmailAddress: "Please enter an email address.",
  auth_pleaseEnterAPassword: "Please enter a password/verification code.",
  auth_returnToLogin: "Return to Login",
  auth_submit: "Submit",
  auth_verificationCode: "Verification Code",
  colon: ":",
  common_add: "Add",
  common_addAndReplace: "Add and replace",
  common_all: "All",
  common_color: "Color",
  common_companiesSitesZones: "Companies/Sites/Zones",
  common_day: "Day",
  common_deactivate: "Deactivate",
  common_device: "Device",
  common_device_add: "Add Device",
  common_exporting: "Exporting",
  common_fri: "Fri",
  common_friday: "Friday",
  common_from: "From",
  common_loading: "Loading",
  common_luke: "Stockify",
  common_lukeAbout1:
    "The Stockify  AI platform employs artificial intelligence (AI) and business rules to take real-time decisions.",
  common_lukeAbout2:
    "Our platform Stockify  AI likes to Learn. It uses interactions to Understand what is happening, to Know what to do next using fact-based decisions. Stockify  AI then Executes actions that overcome business challenges, to consistently deliver measurable value.",
  common_lukeAbout3: "Stockify  AI is always learning, always improving.",
  common_mon: "Mon",
  common_monday: "Monday",
  common_new: "New",
  common_noOptions: "No options",
  common_noZoneInSite: "No zone found in this site.",
  common_of: "of",
  common_print: "Print",
  common_send_email: "Send email",
  common_sat: "Sat",
  common_saturday: "Saturday",
  common_selected: "selected",
  common_selectSite: "Select site",
  common_selectSiteFirst: "Select site first",
  common_selectZone: "Select zone",
  common_site: "Site",
  common_site2: "Site",
  product_code: "JRV Code",
  vendor_name: "Vendor",
  vendor_num: "Vendor Item No",
  manu_item_code: "Manufacturer Item Code",
  code_bin: "Location Code",
  min_cap: "MIN",
  max_cap: "MAX",
  common_sun: "Sun",
  common_sunday: "Sunday",
  common_textCopiedToClipboard: "Text copied to clipboard.",
  common_thu: "Thu",
  common_thursday: "Thursday",
  common_to: "To",
  common_tue: "Tue",
  common_tuesday: "Tuesday",
  common_upload: "Upload",
  common_wed: "Wed",
  common_wednesday: "Wednesday",
  common_week: "Week",
  common_zone: "Zone",
  companies_address: "Address",
  companies_assignedProfiles: "Assigned profiles",
  companies_company: "Company",
  companies_companyNew: "New Company",
  companies_companyType: "Company Type",
  companies_createdSuccessfully: "created successfully",
  companies_creationFailed: "creation failed",
  companies_device: "Device",
  companies_deviceNew: "New Device",
  companies_devices: "Devices",
  companies_deviceType: "Device Type",
  companies_externalDevices: "External Devices",
  companies_lieaDevices: "LIEA Devices",
  companies_newCompany: "New Company",
  companies_newDevice: "New Device",
  companies_newSite: "New Site",
  companies_newZone: "New Zone",
  companies_parentEdgeDevice: "Parent Edge Device",
  companies_site: "Site",
  companies_siteNew: "New Site",
  companies_siteType: "Site Type",
  companies_zone: "Zone",
  companies_zoneNew: "New Zone",
  companies_zones: "Zones",
  companies_zoneType: "Zone Type",
  custom: "custom",
  delete: "Delete",
  unselect_commands: "Deselect products with 'Order in progress'",
  order_jrv: "ORDER",
  order_noun_jrv: "Order",
  vmi_list: "VMI List",
  qty_abv: "Qty",
  order_request_warning: "Only selected products will be placed on order.",
  edit: "Edit",
  custom_css: "125",
  dashboard_activeAverage: "Active Period Average",
  dashboard_activeCases: "Active Cases",
  dashboard_additionalMetrics: "Additional Metrics",
  dashboard_aggregateFunction: "Aggregate Function",
  dashboard_all: "All",
  dashboard_allOk: "All OK",
  dashboard_allowed: "Access Allowed",
  dashboard_allProfiles: "all profiles",
  dashboard_allSites: "All Sites",
  dashboard_allSymptoms: "All Symptoms",
  dashboard_allTime: "All",
  dashboard_assets: "Assets",
  dashboard_assistance: "Assistance & Denied",
  dashboard_assistanceRequired: "Assistance Required",
  dashboard_assistanceTopReasons: "Assistance Top Reasons",
  dashboard_atLeast1Screening: "At least 1 screening",
  dashboard_automationEfficiency: "Automation Efficiency",
  dashboard_averageTime: "Average Time",
  dashboard_averageTimeAtGate: "Average Time at Gate",
  dashboard_averageTimeAtKiosk: "Average Time at Kiosk",
  dashboard_averageTimeInYard: "Average Time in Yard",
  dashboard_averageTimeTrailerYard: "Average time Trailer inside yard",
  dashboard_averageTimeTruckSite: "Average time Truck on site",
  dashboard_barcode: "Barcode:",
  dashboard_bodytemp: "Body Temp",
  dashboard_by_carriers: "View by Carrier",
  dashboard_by_sites: "View by Site",
  dashboard_byCarrier: "View by carrier",
  dashboard_bySite: "View by site",
  arrival: "Arrival",
  departure: "Departure",
  dashboard_carrier: "Carrier",
  dashboard_cars: "Cars",
  dashboard_chooseMetrics: "Choose Metrics",
  dashboard_clear: "Clear",
  dashboard_comments: "Comments",
  dashboard_company: "Company",
  dashboard_confirmedlaboratory: "Confirmed Laboratory",
  dashboard_contact: "COVID-19 Contact",
  dashboard_containers: "Containers",
  dashboard_cough: "Cough",
  dashboard_custom: "Custom",
  dashboard_custom2: "Custom",
  dashboard_date: "Date",
  dashboard_day: "day",
  dashboard_days: "days",
  dashboard_deltacars: "Delta Cars",
  dashboard_deltatrailers: "Delta Trailers",
  dashboard_deltatrucks: "Delta Trucks",
  dashboard_denied: "Access Denied",
  dashboard_devices: "Device(s)",
  dashboard_diarrhea: "Diarrhea",
  dashboard_display: "Display",
  dashboard_distinctLicensePlates: "Distinct License Plates",
  dashboard_driveIn: "Drive In",
  dashboard_driveInOutCounts: "Drive In/Out Counts",
  dashboard_driveInPreAuth: "Drive In Pre-Authorization",
  dashboard_driveInResult: "Drive In Result",
  dashboard_driveOut: "Drive Out",
  dashboard_driveOutPreAuth: "Drive Out Pre-Authorization",
  dashboard_driveOutResult: "Drive Out Result",
  dashboard_driverFirstname: "Driver's First Name",
  dashboard_driverFrAttempt: "driver FR attempt",
  dashboard_driverLastname: "Driver's Last Name",
  dashboard_endDate: "End Date",
  dashboard_entrance: "Entrance",
  dashboard_entranceExit: "Entrance/Exit",
  dashboard_entrances: "Entrances",
  dashboard_entrancesExits: "Entrances/Exits",
  dashboard_entryExitAi: "Entry/Exit AI",
  dashboard_entryExitIA: "Entry/Exit IA",
  dashboard_entryStatus: "Entry Status",
  dashboard_exit: "Exit",
  dashboard_exits: "Exits",
  dashboard_exportCSV: "CSV Export",
  dashboard_faceRecognized: "Face Match",
  dashboard_failed_to_detect: "Failed to Detect",
  dashboard_failedSurveys: "Questionnaire With Risks",
  dashboard_fatigue: "Fatigue",
  dashboard_fever: "Detected Fever",
  dashboard_feverdetected: "Fever Detected",
  dashboard_fr: "FR:",
  dashboard_globalAverage: "Global Average (w/ 0)",
  dashboard_graph: "Graph",
  dashboard_headache: "Headache",
  dashboard_hours: "hour(s)",
  dashboard_hspSitesRiskChart: "HSP Onsite Risk",
  dashboard_humanCount: "Human Count",
  dashboard_humanIdentification: "Human Identification",
  dashboard_humans: "Humans",
  dashboard_kioskAverageSurveyTime: "Kiosk average survey time:",
  dashboard_kioskMetrics: "Kiosk Metrics",
  dashboard_kioskOnSiteResults: "KIOSK/Onsite Results",
  dashboard_kioskProfileIdentification: "Kiosk profile identification",
  dashboard_kioskQuestionnaireAverageWaitTime: "Kiosk Visit Average Time",
  dashboard_kioskThermalMeasurements: "Kiosk thermal measurements:",
  dashboard_kioskVisits: "Kiosk Visits",
  dashboard_last2days: "Last 2 days",
  dashboard_last7days: "Last 7 days",
  dashboard_lastDetectionOfProfiles:
    "Last detection of profiles in sites and zones.",
  dashboard_lastWeek: "Last week",
  dashboard_leastPerformingZones: "Least Performing Zones",
  dashboard_loadingData: "Loading Data",
  dashboard_logType: "Log Type",
  dashboard_lostOfSmell: "Loss of smell",
  dashboard_lostsmell: "Lost of smell",
  dashboard_lprMatch: "LPR match",
  dashboard_max: "Max",
  dashboard_min: "Min",
  dashboard_misc: "MISC",
  dashboard_modifiedOn: "Modified On",
  dashboard_nb_visits: "Number of Visits",
  dashboard_nbDormantTrailers: "Number of Dormant Trailers",
  dashboard_nbSelectedProfiles: "Number of selected profiles:",
  dashboard_nbSelectedSites: "Number of selected sites:",
  dashboard_nbTrailerYard: "Nb of trailers in yard",
  dashboard_nbVisitTotal: "Nb of visits total",
  dashboard_no_visual_reference: "No visual reference",
  dashboard_noDataFound: "No data found with the parameters provided.",
  dashboard_noScreening: "No screening",
  dashboard_nose: "Runny Nose",
  dashboard_numberOfVehicles: "Number of Vehicles",
  dashboard_numberOfVisits: "Number of Visits",
  dashboard_ocrLprReadings: "OCR/LPR Readings",
  dashboard_ocrMatch: "OCR match",
  dashboard_onsite: "Onsite",
  dashboard_onsiteDecision: "Onsite Decisions",
  dashboard_onSites: "On Sites",
  dashboard_others: "Others",
  dashboard_peopleCount: "People Count",
  dashboard_period: "Period",
  dashboard_physicalcontact: "Physical Contact",
  dashboard_privateVehicles: "Private Vehicles",
  dashboard_profilesSelected: "Profiles Selected",
  dashboard_protection: "Protection (Survey Results)",
  dashboard_questionnaireCount: "Questionnaire Count",
  dashboard_questionnaireResults: "Online & Onsite Results",
  dashboard_remote: "Remote",
  dashboard_requireAssistance: "Requires Assistance",
  dashboard_resetFilters: "Reset Filters",
  dashboard_respiratory: "Respiratory Issues",
  dashboard_respiratoryproblems: "Respiratory Problems",
  dashboard_riskCategories: "Risk Categories",
  default: "Default",
  category: "Category",
  manu_name: "Manufacturer Name",
  manu_code: "Manufacturer Code",
  dashboard_riskTooltip:
    'This is the sum of the "Requires Assistance" and "Access Denied" decisions.',
  dashboard_sampleRate: "Sample Rate",
  dashboard_screeningCoverage: "Screening Coverage",
  dashboard_search: "Search",
  dashboard_securityGuard: "Security Guard",
  dashboard_settings: "Settings",
  dashboard_shortnessbreath: "Shortness Breath",
  dashboard_showing: "Showing",
  dashboard_site: "Site",
  dashboard_site2: "Site:",
  dashboard_smell: "Loss of Smell or Taste",
  dashboard_soreness: "Muscle Soreness",
  dashboard_startDate: "Start Date",
  dashboard_switchToDateRange: "Switch to date range",
  dashboard_switchToPeriod: "Switch to period",
  dashboard_tailgate: "Tailgate",
  dashboard_tailgates: "Tailgates",
  dashboard_temp: "Body Temperature",
  dashboard_throat: "Sore Throat",
  dashboard_time: "Time",
  dashboard_today: "Today",
  dashboard_topReasons: "Top Reasons (Assistance Required)",
  dashboard_topSymptoms: "Onsite Top Symptoms",
  dashboard_topVisitDuration: "Top Visit Duration",
  dashboard_total: "Total",
  dashboard_totalEntrances: "Total Entrances",
  dashboard_totalExits: "Total Exits",
  dashboard_totalNbOfProfiles: "Total current active profiles",
  dashboard_totalOnsiteCounts: "Total onsite counts",
  dashboard_totalOffsiteCounts: "Total offsite counts",
  dashboard_Offsite: "Offsite(s)",
  dashboard_totalScreeningCounts: "Total Screening Counts",
  dashboard_totalVehicles: "Total Vehicles",
  dashboard_totalVisits: "Total visits:",
  dashboard_trailerDormantYard: "Trailer dormant in yard",
  dashboard_trailers: "Trailers",
  dashboard_trailersContainers: "Trailers/Containers",
  dashboard_travel: "Travel",
  dashboard_trucks: "Trucks",
  dashboard_trucksWithTrailer: "Trucks with trailer",
  dashboard_type: "Type:",
  dashboard_uniqueEmployees: "Unique Profiles",
  dashboard_unknown: "Unknown:",
  dashboard_values: "Values:",
  dashboard_vehicles: "Vehicles",
  dashboard_vehiclesOnSite: "Vehicles on site",
  dashboard_viewAll: "View all",
  dashboard_waitTime: "Time",
  dashboard_waitTime2: "Wait Time",
  dashboard_weeks: "week(s)",
  dashboard_withOcr: "with OCR",
  dashboard_withPlate: "with plate",
  dashboard_withTrailer: "with trailer",
  dashboard_wrong_detection: "Wrong Detection",
  dashboard_yesterday: "Yesterday",
  dashboard_zone: "Zone:",
  dashboard_zones: "Zone(s)",
  dashboard_zones2: "Zone(s):",
  message: "Message",
  enabled_yes: "Enabled",
  enabled_no: "Not enabled",
  error_errorEncountered: "Error Encountered",
  error_failedLoadData: "Failed to load data from database.",
  error_failedLoadProfile: "Failed to load user's profile.",
  error_failedLoadProfileData: "Failed to load requested profile.",
  error_failedToLoad: "Failed to load",
  error_failedToUpdateProfile: "Failed to update profile.",
  events_active: "Active",
  events_allEvents: "All Events",
  events_createdBy: "Created By",
  events_createdOn: "Created On",
  order_createdBy: "Created By",
  order_createdOn: "Created On",
  quantity2: "Quantity",
  events_end: "End",
  events_eventGroupId: "Event Group ID",
  events_eventGroups: "Event Groups",
  events_eventType: "Event Type",
  events_goToEventsPage: "Go to Events page",
  events_id: "ID",
  events_lieaDevice: "LIEA Device",
  events_no: "No",
  events_primaryAttributes: "Primary Attributes",
  events_profileMatch: "Profile Match",
  events_profileTag: "Profile Tag",
  events_secondaryAttributes: "Secondary Attributes",
  events_site: "Site",
  events_start: "Start",
  events_tag: "Tag",
  events_yes: "Yes",
  events_zone: "Zone",
  footer_poweredBy: "Powered by",
  frdefinition_collection: "Collection Name",
  frdefinition_description: "Description",
  frdefinition_name: "Name",
  frdefinition_provider: "FR Provider",
  Invalid_containerID_ISO6346:
    "Invalid ISO 6346 Container ID (10 or 11-digits required)",
  Invalid_container_size_and_type:
    "Invalid container ‘Size and Type Code’ (SATC)",
  Invalid_custom_Container_ID: "Invalid custom Container ID",
  Invalid_Height:
    "Invalid height (2nd digit, expecting: 0,2,4,5,6,8,9,C,D,E,F)",
  Invalid_Length: "Invalid length (1st digit, expecting: 1,2,3,4,B,CG,H,LM,N)",
  Invalid_Width: "Invalid width (2nd digit, expecting: 0,2,4,5,6,8,9,C,D,E,F)",
  Invalid_Desc:
    "Invalid description (3rd/4th digits, expecting: 0-9, G,V,B,S,R,H,U,P,T,A)",
  Invalid_Category:
    "Invalid category (3rd/4th digits, expecting: 0-9, G,V,B,S,R,H,U,P,T,A)",
  inventory_placed: "Inventory updated",
  inventory_placed_with_sdel: "Inventory updated, SDEL completed",
  label_printer_format_2x1: "2x1",
  label_printer_format_4x1: "4x1",
  label_printer_selection: "Select Printer",
  label_which_printer: "Please select the printer loaded with ",
  label_which_printer_2: " inch labels.",
  label_printer_not_found:
    "No label printer found.  Please connect a printer and try again.",
  label_printer_error: "Error printing to ",
  label_printer_error_2: " inch label printer. Please try again.",
  label_printer_bulk_bins: "Print all bin labels",
  label_printer_bulk_confirm:
    "You are about to print {count} label(s) in {format} format for the bins of {zone}. Continue?",
  label_printer_bulk_empty:
    "No bin label to print for this level.",
  label_printer_bulk_error:
    "Unable to retrieve the bin labels of this level. Please try again.",
  onsitecounts_warning:
    "No email is associated to your profile. Please associate an email and try again.",
  onsitecounts_ok: "Your reports are being generated and will be sent to ",
  onsitecounts_ok_end: " as soon as they are ready.",
  ordering_quantities: "Ordering quantities",
  eoq_title: "Economic Order Quantity (EOQ)",
  required_field: "Field Required",
  existing_carrier: "Existing Carrier",
  orders_base_unit: "Base unit",
  product_state: "State",
  product_state_active: "Active",
  product_state_blocked: "Blocked",
  product_state_deleted: "Deleted",
  product_state_obsolete: "Obsolete",
  profiles_accepted: "Accepted",
  profiles_active: "Active",
  profiles_addAnother: "Add another",
  profiles_addAnotherProfile: "Add another profile",
  profiles_addAssociationTo: "Add association to:",
  profiles_addPhotos: "Add photo(s)",
  profiles_address1: "Address 1",
  profiles_answerGiven: "Answer(s) given",
  profiles_answers: "Answers",
  profiles_archived: "Archived",
  profiles_archivedImages: "Archived Photos",
  profiles_archivedPolicies: "Archived Policies",
  profiles_archivedSelectedPhotos: "Archive selected photo(s)",
  profiles_assignedCompany: "Assigned Company",
  profiles_assignedSite: "Assigned Site",
  profiles_assignedZone: "Assigned Zone",
  profiles_assignmentWarningCompany:
    "Warning: this profile is not assigned to any company. Do you wish to continue?",
  profiles_assignmentWarningSite:
    "Warning: this profile is not assigned to any site. Do you wish to continue?",
  profiles_associateThisProfileWithOtherProfiles:
    "Associate this profile with other profiles.",
  profiles_association: "Association",
  profiles_associations: "Associations",
  profiles_atLeastOneRequired: "At least one required",
  profiles_attempt: "Attempt",
  profiles_attempts: "attempt(s)",
  profiles_attribute: "Attribute",
  profiles_barcode: "Barcode",
  profiles_barcodeAlreadyInUse: "Barcode already exists.",
  profiles_captured: "Captured Photos",
  profiles_captured2: "Captured Photo(s)",
  profiles_carrier: "Carrier",
  profiles_city: "City",
  profiles_color: "Color",
  profiles_comments: "Comments",
  profiles_company_id: "Assigned Company",
  profiles_compliance: "Compliance",
  profiles_complianceDeferral: "Compliance Deferral",
  profiles_consent: "Consent",
  profiles_containerProfile: "Container Profile",
  drag_drop: "(or drag 'n drop files here)",
  content_description: "Content Description",
  file: "File",
  profiles_containerProfile1: "Container Profile 1",
  profiles_containerProfile2: "Container Profile 2",
  profiles_containerType: "Container Type",
  profiles_context: "Context",
  profiles_copyToContext: "Copy to context",
  profiles_copyToIndexed: "Copy to indexed",
  profiles_copyToUnindexed: "Copy to unindexed",
  profiles_country: "Country",
  profiles_covid19: "Covid-19",
  profiles_covidMsg1: "Thank you",
  profiles_covidMsg2:
    "for having completed the questionnaire. In doing so, you are contributing in saving lives.",
  profiles_covidMsgClear:
    "Based on your answers, you are clear to come to our facility.",
  profiles_covidMsgClear2: "Good to go.",
  profiles_covidMsgWarning:
    "Based on your answers, you might be infected with Covid-19 and therefore, we highly recommend that you stay home and seek medical advice.",
  profiles_covidMsgWarning2: "Go see nurse.",
  profiles_createdBy: "Created By",
  profiles_createdOn: "Created On",
  profiles_croppedImage: "Cropped Image",
  profiles_currentlyLocatedIn: "Currently located in:",
  profiles_currentProfile: "Current Profile",
  profiles_d: "day(s)",
  profiles_dacId: "DAC ID",
  next: "Next",
  profiles_dataPolicy: "Data Policy",
  profiles_dataPolicyLongMsg:
    "You chose not to notify the individual and obtain their consent once enrolled. You may have already obtained it separatly, hence why you chose to avoid this step. Please ensure you are not in violation with any company policy. In the event you are not sure, we recommend you save the profile without enrolling and contact the responsible party for next steps.",
  profiles_dataPolicyNotify:
    "Notify the individual once enrolled to share the data policy and obtain their consent.",
  profiles_dataPrivacy: "Data Privacy",
  profiles_dataPrivacyText:
    "Please read each document below and indicate if you consent or not.",
  profiles_dateCompleted: "Date/Time Completed",
  profiles_dateTime: "Date and Time",
  profiles_deleteProfile: "Delete profile",
  profiles_deleteWarning: "Do you really want to delete this profile?",
  profiles_description: "Description",
  attributes_common: "Common attributes",
  volume: "Volume",
  add_zone: "Add Zone",
  event_group_remove: "Are you sure you wish to remove this detection?",
  profile_remove:
    "Are you sure you wish to remove this profile from the event?",
  profiles_deselectAll: "Deselect all",
  profiles_details: "Details",
  name_reservation: "Name of Reservation",
  color_reservation: "Reservation Color",
  profiles_detectionId: "Detection",
  profiles_deviceName: "Device Name",
  profiles_digest: "Digest",
  profiles_downloadCsv: "Download CSV",
  profiles_downloadPdf: "Download PDF",
  profiles_driver: "Driver",
  profiles_driverLicense: "Driver's License",
  profiles_elprConfidenceIndex: "ELPR Confidence Index",
  profiles_elprMatchesTemplates: "ELPR Matches Templates",
  profiles_email: "Email",
  profiles_emailAlreadyInUse: "Email address already exists.",
  profiles_employeeId: "Employee ID",
  profiles_employer: "Employer",
  profiles_end: "End",
  profiles_enroll: "Enroll",
  profiles_enrolling: "Enrolling profile",
  profiles_enrollSelectedPhotos:
    "Enroll profile with selected photo(s) (indexed)",
  profiles_entrance: "Entrance:",
  profiles_entryStatus: "Authorization",
  profiles_error: "Error",
  profiles_eventGroupId: "Event Group ID",
  profiles_eventId: "Event ID",
  profiles_events: "Events",
  profiles_eventType: "Event Type",
  profiles_eventVersion: "Event Version",
  profiles_exit: "Exit:",
  profiles_fail: "Fail",
  profiles_failed: "Failed",
  profiles_failedImages: "Failed Photos",
  profiles_firstName: "First Name",
  profiles_formatInvalid: "Invalid Format",
  profiles_fullContextImage: "Full Context Image",
  profiles_goToFullProfile: "Go to full profile",
  profiles_goToProfile: "Go to profile",
  profiles_groupView: "Group View",
  profiles_hideArchived: "Hide Archived",
  profiles_historicRecordsTitle:
    "Historic Site Entrance/Exit DAC (Distribution Access Control) Records Found",
  profiles_historyLog: "History Log",
  profiles_historyView: "History View",
  profiles_humanProfile: "Human Profile",
  profiles_iAccept: "I Accept",
  profiles_iConfirm: "I Confirm",
  profiles_iHaveRead: "I have read this document.",
  profiles_images: "Images",
  profiles_inactive: "Inactive",
  profiles_indexed: "Indexed",
  profiles_indexedImages: "Indexed Photo(s)",
  profiles_indexingPhotosInProgress: "Indexing Photos in progress",
  profiles_indexWarning:
    "Selected photos may be seen in the Unindexed section if the indexation is still processing in the background. Depending on the number of photos you selected, this might take a while. Refresh the page or return back at a later time to see the final state of the indexation (Indexed or Failed).",
  profiles_individuals: "Individuals",
  profiles_iRefuse: "I Refuse",
  profiles_is: "Is",
  profiles_language: "Language",
  profiles_lastName: "Last Name",
  profiles_left: "left",
  profiles_licensePlate: "License Plate",
  profiles_licensePlateOrOcr:
    "A license plate OR at least one selected OCR entry is required.",
  profiles_lieaDeviceId: "LIEA Device ID",
  profiles_lieaLprVersion: "LIEA LPR Version",
  profiles_lieaMacAddress: "LIEA Mac Address",
  profiles_lieaTimestamp: "LIEA Timestamp",
  profiles_loadMore: "Load More",
  profiles_localStorage: "Local Storage...",
  profiles_location: "Location",
  profiles_location2: "Zone",
  profiles_logEntries: "Log Entries",
  profiles_logType: "Activity Type",
  profiles_lprAlreadyExists: "License plate already exists in another profile.",
  profiles_lprHistoricRecords:
    "unknown profile records having this license plate.",
  profiles_main: "Main",
  profiles_make: "Make",
  profiles_model: "Model",
  profiles_modifiedOn: "Processed On",
  profiles_name: "Name",
  profiles_newProfile: "New Profile",
  profiles_no: "No",
  profiles_noResultsFound: "No results found",
  profiles_note: "Note",
  profiles_notes: "Notes",
  profiles_notOnSite: "Not on site",
  profiles_objects: "Objects",
  profiles_ocrAlreadyExists: "OCR entry already exists in another profile.",
  profiles_ocrHistoricRecords1: "unknown profile records having",
  profiles_ocrHistoricRecords2: "unique OCR entries.",
  profiles_ocrValues: "OCR Entries",
  profiles_online: "Online",
  profiles_onSite: "On-site",
  profiles_optional: "Optional",
  profiles_other: "Other",
  profiles_ownerCompanyId: "Owner Company Id",
  profiles_ownerProfileId: "Owner Profile Id",
  profiles_parentEventId: "Parent Event ID",
  profiles_pass: "Ok",
  profiles_passengerProfile: "Passenger Profile",
  profiles_password: "Password",
  profiles_passwordExpiration: "Password Expiration",
  profiles_pending: "Pending",
  profiles_pendingConsent: "Pending consent",
  profiles_period: "Period",
  profiles_phoneAlreadyInUse: "Phone number already exists.",
  profiles_phoneNumber: "Phone Number",
  profiles_photo: "Photo",
  profiles_photos: "Photos",
  profiles_photosAreRequiredToEnrollHumanProfiles:
    "Photos are required to enroll and identify human profiles.",
  profiles_photosCanBeAddedLater: "Photos can be added at a later time.",
  profiles_photosSaved: "photo(s) added under the Photos tab in Profile page.",
  profiles_pleaseConfirmRead:
    "Please confirm that you have read this document.",
  profiles_policyAlertDenied:
    "Some policies must be accepted before using the software.",
  profiles_policyAlertWarning: "Some policies are pending consent.",
  profiles_policyDocument: "Policy Document",
  profiles_policyNotFound: "Policy Not Found",
  profiles_policyType: "Policy Type",
  profiles_postalCode: "Postal Code",
  profiles_preferedLanguage: "Preferred Language",
  profiles_preferedModeOfCommunication: "Preferred Mode of Communication",
  profiles_privateUserData: "Private User Data",
  profiles_proceedWithEnrollment: "Proceed with enrollment",
  profiles_processedBy: "Processed By",
  profiles_profile: "Profile",
  profiles_profileCreated: "Profile created successfully!",
  signUp: "Create account",
  profiles_profileCreatedButNotEnrolled:
    "Profile created successfully but not enrolled.",
  profiles_profileEnrolled: "Profile enrolled successfully!",
  profiles_profileEnrollmentFailed: "Profile not enrolled.",
  profiles_profileGlobalSearch: "Profile Global Search",
  profiles_profileName: "Profile Name",
  profiles_profilePhoto: "Profile Photo",
  profiles_profileSaved: "Profile saved successfully!",
  profiles_profileType: "Profile Type",
  profiles_profileTypes: "Profile Types",
  profiles_publishedDate: "Published Date",
  profiles_questionnaire: "Questionnaire",
  profiles_questions: "Questions",
  profiles_read: "Read",
  profiles_referenceEventId: "Reference Event ID",
  profiles_refused: "Refused",
  profiles_remote: "Remote",
  profiles_required: "Required",
  profiles_requiredNow: "Required Now",
  profiles_results: "Results",
  profiles_resultsInstructions: "Results/Instructions",
  instructions: "Instructions",
  allowed_time_before: "Allowed Time Before",
  allowed_time_after: "Allowed Time After",
  activity_duration: "Activity Duration",
  profiles_rfid: "RFID",
  profiles_rfidAlreadyInUse: "RFID already exists.",
  profiles_riskLevel: "Risk Level",
  profiles_roles: "Role(s)",
  profiles_saveWithoutEnrolling: "Save without enrolling",
  profiles_saving: "Saving",
  profiles_savingPhotos: "Saving photos",
  profiles_searchProfile: "Search Profile",
  profiles_searchProfileToAdd: "Search profile to add",
  profiles_secondary: "Secondary",
  profiles_selectAll: "Select All",
  profiles_selectDocumentInTheTable: "Select document in the table.",
  profiles_selectProfileTypeToAdd: "Select profile type to add",
  profiles_selectQuestionnaire: "Select questionnaire",
  profiles_showArchived: "Show Archived",
  profiles_site: "Site",
  profiles_sites: "Sites",
  profiles_siteZone: "Site/Zone",
  profiles_skip: "Skip",
  profiles_skipped: "Skipped",
  profiles_start: "Start",
  profiles_stateProvince: "State/Province",
  profiles_stats: "Stats",
  profiles_status: "Status",
  profiles_stringFound: "String Found",
  profiles_submittedOn: "Submitted on",
  profiles_survey: "Survey",
  profiles_surveyId: "Survey ID",
  profiles_tag: "Tag",
  profiles_tags: "Tags",
  profiles_tailgate: "Tailgate",
  profiles_toAddPhotosGoToTab:
    "To add/delete photos, go to the Photos tab on the Profile page.",
  profiles_toRead: "To Read",
  profiles_total: "Total:",
  profiles_trailerProfile: "Trailer Profile",
  profiles_trailerProfile1: "Trailer Profile 1",
  profiles_trailerProfile2: "Trailer Profile 2",
  profiles_trailerType: "Trailer Type",
  profiles_type: "Type",
  profiles_unindexed: "Unindexed",
  profiles_unindexedImages: "Unindexed Photos",
  profiles_unindexSelectedPhotos: "Unindex selected photo(s)",
  profiles_username: "Username",
  profiles_userRole: "User Role",
  profiles_vehicle: "Vehicle",
  profiles_vehicleProfile: "Vehicle Profile",
  profiles_vehicleType: "Vehicle Type",
  profiles_verification: "Verification",
  profiles_version: "Version",
  profiles_viewEventGroup: "View Event Group",
  profiles_vin: "VIN",
  profiles_w: "week(s)",
  profiles_warningHistoricRecords1:
    "Creating this profile will associate (override)",
  profiles_warningHistoricRecords2: "records to this profile.",
  profiles_year: "Year",
  profiles_yes: "Yes",
  zone_details: "Zone Details",
  label: "Label",
  zone_delete:
    "Are you sure you want to delete this area and its entire tree? This operation is irreversible.",
  profiles_yesAnswers: '"Yes" answers',
  profiles_zone: "Zone",
  profiles_zoneTypes: "Zone types",
  pzi_open_order: "Order in progress",
  pzi_units_edit_instructions:
    "Select the quantities that you want displayed on this product's ordering screen.",
  pzi_units_view_instructions:
    "The ordering quantities with a green checkmark will be displayed on this product's ordering screen.",
  pzi_units_will_be_displayed: "Will be displayed",
  scheduler_addVisitor: "Add Visitor",
  scheduler_after: "After",
  scheduler_appointements: "Hosts",
  scheduler_days: "day(s)",
  scheduler_daysStartingOn: "days starting on",
  scheduler_deactivateConfirm: "Delete...",
  scheduler_deleteConfirm: "Do you really want to delete this occurrence?",
  scheduler_doesNotRepeat: "Does not repeat",
  scheduler_repeat: "Repeats...",
  scheduler_ends: "Ends",
  scheduler_endTime: "End Time",
  scheduler_every: "Every",
  scheduler_exceptions: "Exceptions",
  scheduler_host: "Host",
  scheduler_hosts: "Hosts",
  scheduler_months: "month(s)",
  scheduler_newSchedulerOccurrence: "New occurrence",
  scheduler_occurrences: "occurrences",
  scheduler_ofTheMonth: "of the month",
  scheduler_on: "On",
  scheduler_perDayOnAPeriodOf: "per day on a period of",
  scheduler_perTimeSlot: "per time slot:",
  scheduler_recurrenceCustom: "Custom Recurrence",
  scheduler_repeatDaily: "Repeats daily",
  scheduler_repeatDaily2: "Daily",
  scheduler_repeatMonthly: "Repeats monthly",
  scheduler_repeatMonthly2: "Monthly",
  scheduler_repeats: "Repeats",
  scheduler_repeatsEvery: "Repeats every",
  scheduler_repeatWeekly: "Repeats weekly",
  scheduler_repeatWeekly2: "Weekly",
  scheduler_repeatYearly: "Repeats yearly",
  scheduler_repeatYearly2: "Yearly",
  scheduler_scheduler: "Scheduler",
  scheduler_schedulerOccurrence: "Occurrence",
  scheduler_schedulerSettings: "Scheduler Settings",
  scheduler_scheduleType: "Schedule Type",
  scheduler_searchHost: "Search Host",
  scheduler_searchVisitor: "Search Visitor",
  scheduler_showCustomTimeSlots: "Show custom time slots",
  scheduler_siteVisitsAllowed: "Site visits allowed:",
  scheduler_starting: "starting",
  scheduler_startTime: "Start Time",
  scheduler_timeSlot: "time slot",
  scheduler_timeSlots: "Time Slots",
  scheduler_timeSlotsMustNotOverlap: "Time slots must not overlap.",
  scheduler_unknownVisitor: "Unknown Visitor",
  scheduler_visitors: "Visitor(s)",
  scheduler_visitors2: "Visitors",
  scheduler_visitorsAllowedPer: "Visitors allowed per",
  scheduler_visitRestrictions: "Visit Restrictions",
  scheduler_use_same_driver_vehicle:
    "Same Driver/Vehicle as $ACTIVITY_VARIABLE_NAME",
  scheduler_name_reservation: "Name of Reservation",
  scheduler_datepicker_label: "Date",
  scheduler_datepicker_start_date: "Start Date",
  scheduler_datepicker_end_date: "End Date",
  scheduler_instructions: "Instruction",
  scheduler_instructions_language: "Language",
  scheduler_allowed_time_before: "Allowed Time Before",
  scheduler_allowed_time_after: "Allowed Time After",
  scheduler_allowed_time_before_after: "Tolerance Time",
  scheduler_profiles: "Profiles",
  scheduler_zone_door: "Zone",
  scheduler_activities: "Activities",
  scheduler_activity_type: "Activity Type",
  scheduler_documents: "Documents",
  scheduler_schedule_color: "Reservation Color",
  scheduler_currently_expected: "Currently Expected",
  scheduler_requiring_attention: "Requiring Attention",
  scheduler_deactivation_warning:
    "Are you sure you want to delete this occurrence?",
  scheduler_schedule_id: "Schedule ID",
  scheduler_schedule_Direct_link: "View Schedule in New Tab",
  scheduler_view_event_group_lable: "View Event Group",
  sidebar_admin: "Admin & Config",
  sidebar_orders: "Requests and Orders",
  sidebar_vmi_config: "VMI Configuration",
  order_confirmation_1: "Order #",
  view_order: "VIEW ORDERS TABLE",
  order_confirmation_2: " successfully created.",
  order_submit: "Your order is being processed",
  code_product: "Product Code",
  sidebar_products: "Products",
  state: "State",
  ref_external: "External Ref.",
  sidebar_supplychain: "WMS (Warehouse Management System)",
  sector: "Sector",
  sidebar_aiService: "AI service",
  sidebar_alerts: "Alerts",
  sidebar_analytics: "Analytics",
  sidebar_barcode: "Barcode",
  sidebar_businessRules: "Business rules",
  sidebar_companies: "Companies, sites, zones and devices",
  sidebar_companiesSitesZones: "Companies, Sites & Zones",
  sidebar_config: "Configuration",
  sidebar_dashboard: "Dashboards",
  create_zone: "ZONE(S)",
  sidebar_dashboards: "Dashboards & Reports",
  sidebar_dashboards2: "Dashboards",
  sidebar_devices: "Devices",
  sidebar_driveIn: "Drive In",
  sidebar_driveOut: "Drive Out",
  sidebar_events: "System Events",
  sidebar_faceid: "Face ID",
  sidebar_general: "General",
  sidebar_hsp: "HSP (Health Screening & Protection)",
  sidebar_HSP: "HSP",
  sidebar_hspCurrentStatusDashboard: "HSP Main Dashboard (Current status)",
  sidebar_hspDashboard: "HSP Main Dashboard",
  sidebar_hspOriginalStatusDashboard: "HSP Main Dashboard (Original status)",
  sidebar_humanAccess: "Human Access",
  sidebar_IDP: "IDP",
  sidebar_indexSettings: "Index settings",
  sidebar_liveView: "Live View",
  sidebar_mdc: "MDC (Manufacture and distribution center)",
  sidebar_MDC: "MDC",
  sidebar_mdcDashboard1: "MDC Vehicle Entrance/Exit Dashboard",
  sidebar_mdcDashboard2: "MDC Main Dashboard",
  sidebar_me: "Me",
  sidebar_MSP: "MSP",
  sidebar_mspMonthlyTransactionalStats: "MSP Monthly Transactional Stats",
  sidebar_onsiteCounts: "Onsite Counts",
  sidebar_companyCounts: "Company Counts",
  sidebar_peopleCountDashboard: "People Count Dashboard",
  sidebar_profiles: "Profiles",
  sidebar_scheduler: "Scheduler",
  sidebar_search: "Search",
  sidebar_siteAndZones: "Sites and zones",
  sidebar_siteEntranceExit: "Site Entrance/Exit",
  sidebar_statistics: "Statistics",
  sidebar_tags: "Tags",
  sidebar_upcomingEvents: "Upcoming events",
  sidebar_users: "Users & Roles",
  sidebar_vehicleAccess: "Vehicle Access",
  sidebar_vehicleHumanAccess: "Vehicle and Human Access (Live)",
  sidebar_walkInNew: "Walk In (Express)",
  sidebar_walkOutNew: "Walk Out (Express)",
  site_aboutToChange: "You are about to change from:",
  site_active: "Active",
  site_activityDetected: "Activity detected...",
  site_add: "Add",
  site_addComment: "Add Comment",
  site_addNotes: "Add Notes",
  site_address1: "Address 1",
  site_address2: "Address 2",
  site_all: "All",
  site_allow: "Allow",
  site_allowAccess: "Allow Access",
  site_apply: "Apply",
  site_archivedTemperatures: "Archived Temperatures",
  site_atDoor: "At Door",
  site_atGate: "At Gate",
  site_average: "Average",
  site_avg: "Avg",
  site_avgTemp: "Avg Temp.",
  site_back: "Back",
  site_barcode: "Barcode",
  site_blackbodyOffset: "Blackbody Offset",
  site_blackbodyRawValue: "Blackbody Raw Value",
  site_blackbodyState: "Blackbody State",
  site_blank: "Blank",
  site_body: "Body",
  site_bodyTemp: "Body (Kiosk)",
  site_bol: "BOL #",
  site_browse: "Browse...",
  site_by: "by",
  site_byPhoto: "By Photo",
  site_byProfile: "By Profile",
  site_byProfileType: "By Profile Type",
  site_cameraMesuredTemp: "Measured temperatures",
  site_cancel: "Cancel",
  site_captured: "Captured",
  site_capturedPhotos: "Captured Important Photo(s)",
  site_capturedPhotos2: "Captured Photos",
  site_capturedPhotosFrResults: "Captured Photo(s) and FR Results",
  site_capturedTemperatures: "Captured Temperatures",
  site_carrier: "Carrier",
  site_carrier2: "Carrier",
  site_carrierRequired: "Carrier required.",
  site_changed: "Changed",
  site_chrono: "Chrono",
  site_chronoFormat: "(mm:ss)",
  site_city: "City",
  site_clearingIn: "Clearing in:",
  site_close: "Close",
  site_closePhotoWindowWarning1:
    "Creating a new profile will close the photo window.",
  site_closePhotoWindowWarning2: "Do you wish to continue?",
  site_comment: "Comment",
  site_comments: "Comments",
  site_company: "Company",
  site_confirm: "Confirm",
  calc_quant: "QUANTITY CALCULATION",
  select_time_date: "SELECT ZONE",
  date_time: "Date",
  time_zone: "Zone",
  avail_time: "Available Timeslots",
  spec_time: "Specific Time",
  site_container: "Container",
  site_container1: "Container 1",
  site_container2: "Container 2",
  site_content: "Content",
  site_context_lpr: "Context (LPR)",
  site_context_ocr: "Context (OCR)",
  site_context: "Context (Detect)",
  site_contextPhoto: "Context Photo",
  site_contextPhotos: "Context Photo(s)",
  site_correct: "Correct",
  site_correction: "Correction",
  site_country: "Country",
  site_create: "Create",
  site_createAnother: "Create another",
  site_createdByOn: "Created by/on",
  site_createProfile: "Create Profile",
  site_createVehicleProfile: "Create Vehicle Profile",
  site_creating: "Creating",
  site_creatingProfile: "Creating Profile",
  site_cropped: "Cropped",
  site_currentConfiguration: "Current Configuration",
  site_currentDateTime: "Current date and time",
  site_currentEventLog: "Current Event Log",
  site_currentProfile: "Current profile:",
  site_currentState: "Current State:",
  site_dateOverRange: "Selected period cannot exceed",
  site_dateTime: "Date and Time",
  site_deny: "Deny",
  site_denyAccess: "Deny Access",
  site_department: "Department",
  site_description: "Description",
  site_details: "Details",
  site_detected: "Detected",
  site_device: "Device",
  site_dimensions: "Dimensions",
  site_displayedCovidQuestionnaire: "Displayed Covid-19 questionnaire",
  site_doYouWantToUpdateLocation: " Do you want to update the location?",
  site_driveInDriveOut: "Drive In/Drive Out",
  site_driveInOut: "Vehicle Access",
  site_driver: "Human",
  site_driver2: "Driver",
  site_driverFirstName: "Driver's First Name",
  site_driverLastName: "Driver's Last Name",
  site_driverLicense: "Driver's License",
  site_duration: "Duration:",
  duration: "Duration of event",
  site_elapsed: "Elapsed:",
  site_email: "Email",
  site_employeeId: "Employee ID",
  site_employeesCard: "Employee's card",
  site_employeesCardOf: "Employee's card of:",
  site_employer: "Employer",
  site_endDate: "End Date",
  site_entry: "Entrance",
  site_entryStatus: "Authorization",
  site_eventDetails: "Event Details",
  site_eventGroup: "Event Group",
  site_eventGroupId: "Event Group Id:",
  site_events: "Events",
  site_exit: "Exit",
  site_eyesVisible: "Eyes Visible",
  site_face_detect: "Face Detect",
  site_face: "Face",
  site_faceMatch: "Face Match",
  site_failedToCreateProfile: "Failed to create profile.",
  site_fileName: "File Name",
  site_fileSize: "File Size",
  site_fileType: "File Type",
  site_filterDate: "Date Range Filter",
  fileSize_XL: "X-Large (>25 MB)",
  fileSize_L: "Large (>5 MB to <25 MB)",
  fileSize_M: "Medium (>100 KB to <5 MB)",
  fileSize_S: "Small (>5 KB to <100 KB)",
  fileSize_XS: "Tiny (<100 KB)",
  site_filterDateText: "Please select date range to filter the data.",
  site_finalTemperature: "Final Temperature",
  site_firstName: "First Name",
  site_firstNameRequired: "First Name required.",
  site_found: "Found",
  site_frConfiguration: "FR Configuration",
  site_frDefinition: "FR Definition",
  site_frEnroll: "FR Enroll",
  site_fuelLevel: "Fuel Level",
  site_goToEventGroup: "Go to Event Group",
  site_goToFullProfile: "Go to profile",
  site_hide: "Hide",
  site_hideAdditionalColumns: "Hide Additional Columns",
  site_hideRoi: "Hide ROI",
  site_highestScoreMatch: "Highest score match:",
  site_highestScoreProfile: "Highest Score Profile",
  site_historic: "History",
  site_historicSiteentry: "Site Entrance History",
  site_historicSiteexit: "Site Exit History",
  site_historyEvents: "History Events",
  site_human_detect: "Human Detect",
  site_human_exit: "Human Exit",
  site_human: "Human",
  site_humanAccess: "Human Access",
  site_humanDetected: "Human Detected",
  site_identified: "Identified",
  site_indexedPhotos: "Indexed Photo(s)",
  site_inPercent: "(in %)",
  site_internalUse: "(internal use)",
  site_iso: "ISO",
  site_isoTemp: "ISO (Kiosk)",
  site_isTheCorrect: "Is this the correct",
  site_itemToVerify: "Item to verify",
  site_kioskAvgTemp: "Kiosk Avg Temp.",
  site_kioskMaxTemp: "Kiosk Max Temp.",
  site_kioskMinTemp: "Kiosk Min Temp.",
  site_last: "Last",
  site_lastModified: "Last Modified",
  site_lastName: "Last Name",
  site_lastNameRequired: "Last Name required.",
  site_lastVerification: "Last Verification",
  site_licensePlate: "License Plate",
  site_licensePlateRecognition: "License Plate Recognition",
  site_loaded: "Loaded",
  site_loadingData: "Loading Data",
  site_loadMore: "Load +10",
  site_locationUpdate: "Location Update",
  site_log: "Log",
  site_logEntryRef: "Log Entry Ref #",
  site_logs: "Logs",
  site_logType: "Activity Type",
  site_lpr: "LPR",
  site_lprMatch: "LPR Match",
  site_main: "Summary",
  site_main2: "Main",
  site_rented: "Rented",
  site_level: "Level",
  site_position: "Position",
  site_railDetectionEvent: "Rail Detection",
  site_row: "Row",
  site_trainId: "Train ID",
  site_yardEventType: "Yard Event",
  site_client: "Client",
  site_billing_note: "Billing Note",
  email_formatInvalid: "Invalid Format",
  min_six_char: "Minimum 6 characters",
  min_one_digit: "At least 1 digit",
  min_one_special_char: "At least 1 special character",
  min_one_upper: "At least 1 uppercase letter",
  min_one_lower: "At least 1 lowercase letter",
  pass_dont_match: "Passwords do not match.",
  card_exists: "Card number already exists",
  number: "Number",
  number2: "Number",
  file2: "File",
  email_exists: "This email address already exists.",
  card_associated: "This card is associated with another email",
  site_mainDetails: "Main Details",
  completedSignUp:
    "An activation link has been sent to your email address. Please click on the link to activate your account.",
  submitError1:
    "An account already exists for this email address and/or Access Card Number.",
  submitError2: "Please contact your administrator or try logging in.",
  site_make: "Make",
  site_manualTemp: "Body (Manual)",
  site_manualTemp2: "Manual Temp.",
  site_manualTemperature: "Manual Temperature",
  site_mask: "Wearing mask?",
  site_match: "Match",
  site_matchedProfile: "Matched Profile",
  site_matches: "Matches",
  site_matchSuccess: "Match Success",
  site_max: "Max",
  site_maximum: "Maximum",
  site_maxTemp: "Max Temp.",
  site_measure: "Measured Temperature",
  site_measuredTemp: "Measured Temperatures",
  site_measureType: "Measure Type",
  site_metadata: "Metadata",
  site_min: "Min",
  site_minimum: "Minimum",
  site_minTemp: "Min Temp.",
  site_model: "Model",
  site_modifiedOn: "Processed On",
  site_monitorTab: "Select a zone to monitor in a new tab.",
  site_more: "more",
  quantity: "Quantity : ",
  save_changes: "Do you want to save the changes?",
  vendor_item_code: "Vendor Item No",
  jrv_welcome: "Welcome to our supply chain and inventory management solution.",
  jrv_welcome2:
    "OUR MISSION IS TO SIMPLIFY AND OPTIMIZE OUR CUSTOMER'S SUPPLY CHAIN.",
  save_pzi: "You have unsaved changes. Do you want to leave without saving?",
  unit_required:
    "Please provide value for Depth, Width, Height and Unit of measure.",
  is_required: "is required",
  location_vmi: "Location",
  jrv_code: "JRV Code",
  order_cancel:
    "Are you sure you would like to cancel? A new order with those quantities will need to be recreated.",
  order_cancel_error:
    'Since the selected product(s) are the last ones with the "Confirmed" status, they cannot be canceled while other products are still "In Process" status.',
  order_cancel_issue:
    "One or more selected product lines were not updated. [400 error list].",
  order_oreq_cancel: "Cancel Lines",
  order_transmission: "Transmission Errors",
  retry_order_release: "Retry Order Release",
  retry_order_release_confirm: "Would you like to proceed and retry releasing this order?",
  retry_order_release_success: "Order release request has been sent.",
  retry_order_release_error: "Can not release this command",
  null_selection1: "CANCEL",
  null_selection2: "SELECTED LINE(S)",
  device_delete:
    "Are you sure you want to delete this device? This operation is irreversible.",
  replenishment_only: "Replenishment only",
  replenishment_automatic: "Automatic replenishment",
  replenishment_one_step: "Delivery and replenishment in one step",
  order_in_progress_warning:
    "At least one order or request is currently associated with this location or one of its sub-location. Therefore no modification of this location is authorized.",
  replace_po_confirm: "Are you sure you would like to replace these POs?",
  replace_po_confirm_singular:
    "Are you sure you would like to replace this PO?",
  replace_po_confirmed: "POs were replaced.",
  replace_po_confirmed_singular: "PO was replaced.",
  wms_replace: "Replace",
  replace_for: "Replace for",
  sidebar_po_search: "Search PO",
  current_inventory: "Current inventory",
  resultsPerPage: "Results per page",
  lastUpdate: "Last update",
  sidebar_lookup: "Product Lookup",
  selected_vmi: "selected",
  binned: "Binned",
  ordered_quantity: "Ordered quantity",
  invalid_pzi: "Invalid Zone ID",
  all_vmi: "All VMI",
  total_to_come: "Total to come",
  order_request_max_warning: "Entered value exceeds the maximum capacity",
  replenishment_en_route: "In transit",
  replenishment_to_bin: "To bin",
  replenishment_delivered: "Delivered",
  replenishment_outstanding: "To be processed",
  replenishment_completed: "Completed",
  replenishment_cancelled: "Cancelled",
  wms_inventory: "Replenishment/Inventory",
  sidebar_inventory: "Replenishment/Inventory",
  product_errors: "product(s) in error",
  resend_dialog:
    "The selected product(s) have been resent. If you still have an error, please retry later.",
  remove_dialog_p1: "Do you really want to remove the",
  remove_dialog_p2: "selected products from the order?",
  remove_dialog_p3: "Removed products will return into the order request.",
  order_remove: "Remove All",
  order_resend1: "Resend",
  order_resend2: "Product(s)",
  scan_more: "Scan another product",
  table_associate: "Associated",
  search_results: "Results",
  confirm_order: "Order #",
  ogc_reference: "OGC Reference",
  vmi_with: "VMI with requests",
  vmi_without: "VMI without requests",
  reset_fields: "Clear Fields",
  total_quantity: "Total Quantity",
  assisted_request: "Assisted Request",
  manual_request: "Manual Request",
  manufacturer: "Manufacturer",
  manufacturer_code: "Manufacturer Code",
  manufacturer_item_code: "Manufacturer Item Code",
  unit_of_measure: "Unit of Measure",
  pending_order: "Pending Order",
  last_order: "Last order",
  product_on_list: "Product already in the list",
  add_request: "Add Request",
  ready_scan: "Ready to Scan",
  qr_code_scan: "QR SCAN",
  selected_num: "selected",
  unites: " Units",
  unit_weight: "Unit Weight",
  inventory: "Inventory",
  quantity_bin: "Quantity in the bin",
  corres_level: "Corresponds to the level : ",
  site_moveMouseOverImage:
    "Move mouse inside blue square (ROI) to view temperature readings",
  site_name: "Name",
  site_nameRequired: "Name required.",
  site_newCovidQuestionnaire: "New Covid-19 questionnaire",
  site_newEntry: "New Entry",
  site_newTemperature: "New Temperature",
  site_no: "No",
  site_no_po: "No PO",
  site_noCarrier: "No Carrier",
  site_noChanges: "No Changes",
  site_noData: "No Data Available.",
  site_noEntryFound: "No entry found in the selected zone.",
  site_noHumanDetected: "No human detected.",
  site_noLPR: "No license plate recognition available.",
  site_noMatch: "No Match",
  site_noMatchedProfileFound: "No matched profile found.",
  site_none: "None",
  site_noneAboveCreateProfile: "None of the above. Create profile.",
  site_noOCR: "No optical character recognition available.",
  site_noPhoto: "No photo",
  site_noPhotoFound: "No photo found.",
  site_noProfileFound: "No profile found.",
  site_noProfileMatch: "The detection did not match any profile.",
  site_noProfileMsg: "No profile exists. Create profile.",
  site_noProfileMsg2:
    "No profile candidate found with the above LPR/OCR values. Create new profile.",
  site_noQuestionnaireCreated: "No questionnaire created.",
  site_noQuestionnaireFound: "No questionnaire found.",
  site_noSite: "No Site",
  site_noTag: "No Tag",
  site_noteAbout: "Note about:",
  site_noteType: "Type",
  site_General: "General",
  site_CompareResults: "Compare results",
  site_InspectionSafety: "Inspection / Safety",
  site_noTemperatureReading:
    "No temperature reading for the current event log.",
  site_notes: "Notes",
  site_notFound: "Not Found",
  site_notLast: "Not Last",
  site_noTrailerDetected: "No trailer detected.",
  site_noVehicleAtGate: "No vehicle at gate",
  site_noVehicleDetected: "No vehicle detected.",
  site_ocr: "OCR",
  site_ocrMatch: "OCR Match",
  site_ocrValues: "OCR Entries",
  site_ocrValuesMsg: "Selected entries are unique to this profile.",
  site_odometer: "Odometer",
  site_ok: "Ok",
  site_opticalCharacterRecognition: "Optical Character Recognition",
  site_otherProfilesFound: "Other Profiles Found",
  site_override: "Override",
  site_overrideMsg: "Override current profile",
  site_overridenBy: "Overriden  by:",
  site_overridingProfile: "Overriding Profile",
  site_parentZone: "Parent Zone",
  site_passenger: "Passenger",
  site_pastDateTime: "Past date and time",
  site_pastEntries: "Past Entries",
  site_phoneNumber: "Phone Number",
  site_photos: "Photo(s)",
  site_photosMessage:
    "Checked photos will be indexed. Unchecked photos will be kept but not indexed.",
  site_pleaseFillRequiredFields: "Please fill all required fields.",
  site_pleaseProvideLprOrOcr:
    "Please provide a license plate or at least one OCR marked as unique.",
  site_pleaseSelectSite: "Please select a site.",
  site_pleaseSelectZone: "Please select a zone.",
  site_po: "PO #",
  site_postalCode: "Postal Code",
  site_postGate: "Post-Gate",
  site_potentialMatches: "Potential Matches",
  site_preferedLanguage: "Preferred Language",
  site_preferedModeCommunication: "Preferred Mode of Communication",
  site_preGate: "Pre-Gate",
  site_privateVehicle: "Private Vehicle",
  site_processedBy: "Processed By",
  site_product: "Product",
  site_products: "Products",
  site_profile: "Profile",
  site_profileName: "Profile Name",
  site_profileOverridenBy: "Profile overriden by:",
  site_profilePhotos: "Profile Photo(s)",
  site_profiles: "Profiles",
  site_profilesFound: "Profiles Found",
  site_profilesOn: "Profile(s) on",
  site_profilesOnOtherSites: "Profile(s) on other sites",
  site_profileTemperatureHistory: "Profile temperature history",
  site_profileType: "Profile Type",
  site_questionnaires: "Questionnaire(s)",
  site_rawValue: "Raw Value",
  site_reasonForOverride: "Reason for override",
  site_recentlyClosed: "Recently closed",
  site_ref: "Ref #",
  site_registration: "Registration",
  site_request: "Request",
  site_reset: "Reset",
  site_results: "Results",
  site_resultsFound: "Results Found",
  site_rfid: "RFID",
  site_riskLevel: "Risk Level",
  site_rowsPerPage: "Rows per page:",
  site_RuleSets: "Rulesets",
  site_save: "Save",
  site_disableUser: "Disable User",
  site_enableUser: "Enable User",
  site_disableUserConfirm: "Are you sure you want to disable this user?",
  site_enableUserConfirm: "Are you sure you want to enable this user?",
  site_scanToCompleteMobile: "Scan to complete with mobile",
  site_scores: "Scores",
  site_seal: "Seal",
  site_search: "Search",
  site_searchLicensePlate: "Search License Plate",
  site_searchNameOcrLpr: "Search name, OCR, LPR, etc.",
  site_searchOcrLpr: "Search OCR/LPR",
  site_searchVehicle: "Search Vehicle",
  site_secondary: "Secondary",
  site_secondaryDetails: "Secondary Details",
  site_selectConfiguration: "Select Configuration",
  site_selectDepartment: "Select Department",
  site_selectPhotosForProfile:
    "Please select the images you want to associate with the profile.",
  site_selectRowToViewDetails: "Select row to view details",
  site_setTemperatureText:
    "To set a new temperature manually, click on a pixel inside the green rectangle that matches the value/position of the wanted temperature.",
  site_show: "Show",
  site_showAdditionalColumns: "Show additional columns",
  site_showRoi: "Show ROI",
  site_site: "Site:",
  site_site2: "Site",
  site_siteAndZone: "Site and Zone",
  site_siteImpactCount: "Site Impact Count",
  site_specificDateTime: "Enter Specific Date/Time",
  site_stage: "Stage",
  site_startDate: "Start Date",
  site_startTime: "Start Time:",
  site_stateProvince: "State/Province",
  site_status: "Status",
  site_structuralView: "Structural View",
  site_summary: "Summary",
  site_tag: "Tag",
  site_tag2: "Tag",
  site_tailgate: "Tailgate",
  site_tailgating: "Tailgating",
  site_tempBack: "Temp Back",
  site_tempDisplayed: "Displayed",
  site_temperature: "Fever?",
  site_temperatureReadings: "Temperature Readings",
  site_temperatureReadingsDetails: "Temperature Readings Details",
  site_temperatures: "Temperature",
  site_tempFront: "Temp Front",
  site_tempMeasured: "Measured",
  site_tempMiddle: "Temp Middle",
  site_tempType: "Temp. Type",
  site_tempVerbal: "Verbal",
  site_thermalROI: "Thermal ROI",
  site_threatLevel: "Threat",
  site_threatLevel2: "Threat Level",
  site_time: "Time",
  site_timeline: "Timeline",
  site_timestamp: "Timestamp",
  site_to: "To",
  site_totalTimeAtDoor: "Total time:",
  site_totalTimeAtGate: "Total time at gate:",
  site_trailer: "Trailer",
  site_trailer1: "Trailer 1",
  site_trailer2: "Trailer 2",
  site_trailerId: "Trailer #",
  site_trailerName1: "Name",
  site_trailerName2: "Name",
  site_trailerType: "Trailer Type",
  site_truck: "Vehicle",
  site_truck2: "Truck",
  site_type: "Type:",
  site_type2: "Type",
  diss_warning: "Are you sure you want to unlink this product?",
  associated_products: "Associated products",
  associate_product: "ASSOCIATE PRODUCT",
  dissociate_product: "DISSOCIATE PRODUCT",
  site_typeCorrectValue: "Type correct value",
  site_unidentified: "Unidentified",
  site_unindexedPhotos: "Unindexed Photo(s)",
  site_unknown: "Unknown",
  site_unknownDriver: "Unknown Driver",
  site_unknownTrailer: "Unknown Trailer",
  site_unknownVehicle: "Unknown Vehicle",
  site_unmatch: "Unmatch",
  site_unmatchedPhotos: "unmatched photo(s)",
  site_updateProfile: "Update Profile",
  site_updatingProfile: "Updating Profile",
  site_value: "value",
  site_valueConfirmed: "Value confirmed",
  site_valueConfirmedBy: "Value confirmed by:",
  site_valueCorrected: "Value corrected",
  site_valueCorrectedBy: "Value corrected by:",
  site_values: "values",
  site_valueType: "Value Type",
  site_vehicle: "Vehicle",
  site_vehicleAccess: "Vehicle Access",
  site_vehicleAtGate: "Vehicle at gate",
  site_vehicleId: "Vehicle #",
  site_vehicleName: "Name",
  site_vehicleOcr: "Vehicle OCR",
  site_vehicleType: "Vehicle Type",
  site_verification: "Verification",
  site_verified: "Verified",
  site_verify: "Verify",
  site_view: "View",
  site_viewAdditionalColumns: "View Additional Columns",
  site_viewCurrent: "View Current",
  site_viewLess: "View less",
  site_viewMore: "View more",
  site_vin: "VIN",
  site_walkInOut: "Human Access",
  site_wasDetected: "was detected.",
  site_wearingMask: "Wearing Mask?",
  site_with: "With:",
  site_year: "Year",
  site_yes: "Yes",
  zone_parent: "Parent zone: ",
  zone_error:
    "The zone type you want to create cannot be created under this parent zone.",
  site_zone: "Zone",
  site_zoneColor: "Zone Color",
  site_currentSite: "Current Site",
  site_currentZone: "Current Zone",
  site_assignedSiteZone: "Assigned Site / Zone",
  stat_childEventGroups: "Child Event Groups (human, vehicle, trailer)",
  stat_comment: "Comment",
  stat_corrected_value: "Corrected Value",
  stat_correction_event_type_id: "OCR/LPR Type Correction",
  stat_count: "Count",
  stat_detected_value: "Detected Value",
  stat_entranceExitDetail:
    "Entrance/Exit Detail (only list event_groups where status = 3, 4 and 5)",
  stat_entranceExitSummary: "Entrance/Exit Summary - Count by Status",
  stat_event_group_id: "Parent Event Group ID",
  stat_event_group_status_id: "Status",
  stat_event_group_type_id: "Parent Event Group",
  stat_event_id: "Event ID",
  stat_eventGroupId: "Event Group ID",
  stat_eventGroupType: "Event Group Type",
  stat_eventType: "Event Type",
  stat_gateType: "Gate Type",
  stat_imageCrop: "Image Crop",
  stat_lprOcrDetailedView: "LPR/OCR Detailed View",
  stat_lprOcrSummary: "LPR/OCR Summary",
  stat_parent_event_group_created_on: "Processed On",
  stat_parent_event_group_id: "Parent Event Group ID",
  stat_percentage: "Percentage",
  stat_percentageReviewed: "% / Reviewed",
  stat_percentageTotal: "% / Total",
  stat_processed_on: "Processed On",
  stat_status: "Status",
  stat_sum: "Sum",
  stat_type: "Type",
  stats_dacTitle: "DAC Records",
  stats_entrance: "Entrance",
  stats_exit: "Exit",
  stats_frTitle: "FR",
  stats_hspIteractionPoints: "HSP Interaction Points",
  stats_kiosk: "Kiosk",
  stats_lprTitle: "LPR",
  stats_mdcIteractionPoints: "MDC Interaction Points",
  stats_ocrTitle: "OCR",
  stats_online: "Online",
  stats_profilesTitle: "PROFILES",
  stats_total: "Total",
  topbar_aboutLuke: "About Stockify",
  topbar_admin: "Admin",
  topbar_companies: "Companies",
  topbar_configuration: "Configuration",
  topbar_dashboards: "Dashboards",
  topbar_driveInOut: "Vehicle Access",
  topbar_events: "Events",
  topbar_home: "Home",
  topbar_hspCurrentStatusDescription:
    "This dashboard displays up-to-date data and takes manual updates into account.",
  topbar_hspDashboard: "HSP Main Dashboard",
  topbar_hspOriginalStatusDescription:
    "This dashboard displays original data before any manual updates.",
  topbar_idp: "IDP",
  topbar_mdcDashboard1: "MDC Vehicle Entrance/Exit Dashboard",
  topbar_mdcDashboard2: "MDC Main Dashboard",
  topbar_mdcInventoryDashboard: "On-Site Inventory ",
  topbar_me: "Me",
  topbar_mspMonthlyTransactionalStats: "MSP Monthly Transactional Stats",
  topbar_myAccount: "My Account",
  topbar_profiles: "Profiles",
  topbar_schedulerHumanAccess: "Scheduler - Human Access",
  topbar_schedulerVehicleAccess: "Scheduler - Vehicle Access",
  topbar_siteEntranceExit: "Site Entrance/Exit",
  topbar_stats: "Stats",
  topbar_stats2: "Stats 2",
  topbar_stats3: "Stats 3",
  topbar_trainInOut: "Train Access",
  topbar_usersAndRoles: "Users & Roles",
  topbar_vmi_config: "VMI Configuration",
  topbar_walkInOut: "Human Access",
  train_no_matches: "No matches found",
  users_accessType: "Access Type",
  users_accountActivity: "Account Activity",
  users_action: "Action",
  users_createAndInvite: "Create and invite",
  users_dateTime: "Date/Time",
  users_fromProfile: "From Existing Profile",
  users_incorrectEmail: "Invalid username/email address.",
  users_location: "Location (IP address)",
  users_new: "New",
  users_newUser: "New User",
  users_updateUserRole: "Update user role",
  users_editUserRole: "Edit user role",
  users_requiredField: "Required field.",
  users_roles: "Roles",
  users_singleUser: "Single User",
  users_usernameAlreadyInUse: "Username already exists.",
  users_users: "Users",
  users_viewLukeProfile: "View Stockify Profile",
  zone_same_name_warning:
    "A location with this name already exists.  Please enter a different name.",
  assigned_company: "Assigned Company",
  show_company: "Show Company",
  show_site: "Show Site",
  all_companies: "All Companies",
  all_sites: "All Sites",
  sidebar_trainmanifest: "Train Visibility",
  company_count_profile_onsite_details: "On Site Details",
  dashboard_profilesPerPage: "Profils par page",
  sidebar_VMI: "VMI",
  sidebar_vmiConfigurationMetrics: "VMI Configuration Metrics",
  dashboard_vmiConfigurationMetrics_company: "Company",
  dashboard_vmiConfigurationMetrics_site: "Site",
  dashboard_vmiConfigurationMetrics_sector: "Sector",
  dashboard_vmiConfigurationMetrics_vending_machine: "Vending Machine",
  dashboard_vmiConfigurationMetrics_vmi: "VMI",
  dashboard_vmiConfigurationMetrics_pzi: "PZI",
  dashboard_vmiConfigurationMetrics_distinct_products: "Distinct Products",
  dashboard_vmiConfigurationMetrics_users: "Users",
  locomotive: "Locomotive",
  open_hopper: "Open Hopper",
  closed_hopper: "Covered Hopper",
  tanker: "Tanker",
  boxcar: "Box Car",
  flatcar: "Flat Car",
  wellcar: "Well Car",
  autorack: "Auto Carrier",
  centerbeam: "Center Beam Car",
  container: "Container",
  trailer: "Trailer",
  gondola: "Gondola",
  coilcar: "Coil Car",
  train_id: "Train ID",
  current_state: "Current State",
  train_layout: "Train Layout",
  railcar: "Railcar",
  view_train_manifest: "View Train Manifest",
  matched: "Matched",
  unmatched: "Unmatched",
  toggle_luke: "To Stockify profiles",
  toggle_manifest: "To Manifest",
  estimated_arrival: "Planned Arrival",
  luke_sequence: "Stockify Sequence",
  manifest_sequence: "Manifest Sequence",
  manifest_position: "Manifest Position",
  // TODO: REMOVE UNUSED AND DUPLICATES (START)
  number2: "Number",
  empty: "Empty",
  loaded: "Loaded",
  create_another: "Create another",
  select_time_date: "SELECT ZONE",
  avail_time: "Available Timeslots",
  spec_time: "Specific Time",
  date_time: "Date",
  file: "File",
  time_zone: "Zone",
  role: "Filter",
  mdc_timeline: "Timeline",
  what_to: "What to ",
  ref: "Ref #",
  status: "Status",
  PO: "PO",
  yard_visit: "Yard Visit",
  in_yard: "In Yard",
  person_visit: "Person Visit",
  mdc_list: "List",
  drop: "Drop",
  pickup: "Pickup",
  number: "Number",
  file2: "File",
  color_reservation: "Reservation Color",
  arrival: "Arrival",
  departure: "Departure",
  switch: "Switch",
  drag_drop: "(or drag 'n drop files here)",
  content_description: "Content Description",
  liveload: "Live Load",
  liveunload: "Live Unload",
  miscellaneous: "Miscellaneous",
  reservation: "Reservation",
  newvisit: "YARD VISIT - NEW RESERVATION",
  activities: "Activities",
  summary: "Summary",
  move: "Move",
  load: "Load",
  unload: "Unload",
  // TODO: REMOVE UNUSED AND DUPLICATES (END)
  sidebar_spot: "Verification",
  idp_all_dates: "All Dates",
  idp_all_types: "All Types",
  idp_all_importers: "All Importers",
  idp_all_sizes: "All Sizes",
  idp_select_document: "Select result above",
  idp_extract_text: "Extracted text",

  // QR Code Scan
  qrScanDecode: "Failed to decode QR code",
  qrScanFormat: "Invalid QR code format",
  qrScanUrl: "Failed to load QR scan URL",
  qrScanNoUrl: "No URL in QR scan config",
};

// module.exports = En;
export default En;
